import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const relatoriosSlice = createSlice({
  name: 'relatorios',
  initialState,
  reducers: {
    carregarRelatorios: (state, action) => {
      const { key, relatorios } = action.payload;
      state[key] = relatorios;
    },
    atualizarRelatorios: (state, action) => {
      const { key, relatorios } = action.payload;
      state[key] = relatorios;
    },
  },
});

export const { carregarRelatorios, atualizarRelatorios } = relatoriosSlice.actions;

export default relatoriosSlice.reducer;